import { actions } from "2g-form";
import { createModuleReducer } from "2g-utils-redux";

import { FORM_REZERVACE_VYTVORENI_MODULE_KEY } from "./RezervaceVytvoreniForm";

const onSetFormValue = (state, action) => {
  const path = action.payload.path;
  if (action.meta.moduleKey === FORM_REZERVACE_VYTVORENI_MODULE_KEY) {
    const newValues = { ...state.values };
    if (path[0] == "typZdroje") {
      delete newValues.zdroj;
      delete newValues.produkt;
      delete newValues.obdobiOd;
      delete newValues.obdobiDo;
    }
    if (path[0] == "zdroj") {
      delete newValues.produkt;
      delete newValues.obdobiOd;
      delete newValues.obdobiDo;
    }
    if (path[0] == "produkt") {
      delete newValues.datumOd;
      delete newValues.datumDo;
      delete newValues.doplnkoveSluzby;
    }
    state = {
      ...state,
      values: newValues
    };
  }
  return state;
};

export default createModuleReducer({
  [actions.SET_VALUE]: onSetFormValue
});
